var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("div", { staticClass: "operations" }, [
        _c("div", { staticClass: "triggers" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      (!_vm.innerIsEditing ||
                        Boolean(
                          _vm.isSeaHouseChannel && _vm.manifestInfo.manifestId
                        )) &&
                      _vm.manifestInfo.todo !== "new",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.new")))]
              ),
              _vm.isSeaHouseChannel
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.innerIsEditing ||
                          Boolean(
                            _vm.isSeaHouseChannel && _vm.manifestInfo.manifestId
                          ),
                        type: "primary"
                      },
                      on: { click: _vm.copy }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      (!_vm.innerIsEditing ||
                        Boolean(
                          _vm.isSeaHouseChannel && _vm.manifestInfo.manifestId
                        )) &&
                      _vm.manifestInfo.todo !== "new",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.edit2")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      (!_vm.innerIsEditing ||
                        Boolean(
                          _vm.isSeaHouseChannel && _vm.manifestInfo.manifestId
                        )) &&
                      _vm.manifestInfo.todo !== "new",
                    type: "danger"
                  },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
              )
            ],
            1
          )
        ])
      ]),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px", "margin-top": "5px" },
        attrs: {
          "config-module": "130204",
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.finalRowData
        },
        on: { gridReady: _vm.onGridReady }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.containerNo") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        on: {
                          change: function($event) {
                            _vm.editDialog.form.containerNo = _vm.toUpperCaseTrim(
                              _vm.editDialog.form.containerNo
                            )
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.containerNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "containerNo", $$v)
                          },
                          expression: "editDialog.form.containerNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SealNo") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        on: {
                          change: function($event) {
                            _vm.editDialog.form.sealNo = _vm.toUpperCaseTrim(
                              _vm.editDialog.form.sealNo
                            )
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.sealNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "sealNo", $$v)
                          },
                          expression: "editDialog.form.sealNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.eqSize,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "eqSize", $$v)
                          },
                          expression: "editDialog.form.eqSize"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WeighingMethod") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.vgmWeightingMeothd,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "vgmWeightingMeothd",
                              $$v
                            )
                          },
                          expression: "editDialog.form.vgmWeightingMeothd"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isSeaHouseChannel
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TotalWeight2") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: !_vm.isEditing,
                              controls: false,
                              min: 0,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.vgmWeight = _vm.roundHalfUp(
                                  _vm.editDialog.form.vgmWeight,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.vgmWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "vgmWeight", $$v)
                              },
                              expression: "editDialog.form.vgmWeight"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TotalWeight2") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              disabled: !_vm.isEditing,
                              controls: false,
                              min: 0,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.vgmWeight = _vm.roundHalfUp(
                                  _vm.editDialog.form.vgmWeight,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.vgmWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "vgmWeight", $$v)
                              },
                              expression: "editDialog.form.vgmWeight"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "30%" },
                              model: {
                                value: _vm.editDialog.form.vgmWeightUnit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "vgmWeightUnit",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.vgmWeightUnit"
                              }
                            },
                            _vm._l(_vm.WEIGHT_UNIT, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.code, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.VGMLLC") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.vgmLiabilityCompany,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "vgmLiabilityCompany",
                              $$v
                            )
                          },
                          expression: "editDialog.form.vgmLiabilityCompany"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.VGMSignature") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.vgmAutoGraph,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "vgmAutoGraph", $$v)
                          },
                          expression: "editDialog.form.vgmAutoGraph"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Email2") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.contactEmail,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "contactEmail", $$v)
                          },
                          expression: "editDialog.form.contactEmail"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isSeaHouseChannel
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TareWeight") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: !_vm.isEditing,
                              controls: false,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.grossWeight = _vm.roundHalfUp(
                                  _vm.editDialog.form.grossWeight,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.grossWeight,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "grossWeight",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.grossWeight"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TareWeight") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              disabled: !_vm.isEditing,
                              controls: false,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.grossWeight = _vm.roundHalfUp(
                                  _vm.editDialog.form.grossWeight,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.grossWeight,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "grossWeight",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.grossWeight"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "30%" },
                              model: {
                                value: _vm.editDialog.form.grossWeightUnit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "grossWeightUnit",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.grossWeightUnit"
                              }
                            },
                            _vm._l(_vm.WEIGHT_UNIT, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.code, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.telephone,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "telephone", $$v)
                          },
                          expression: "editDialog.form.telephone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WeighingAddress") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.weighingAddress,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "weighingAddress",
                              $$v
                            )
                          },
                          expression: "editDialog.form.weighingAddress"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isSeaHouseChannel
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.WeightTime") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: !_vm.isEditing,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.editDialog.form.weightTime,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "weightTime", $$v)
                              },
                              expression: "editDialog.form.weightTime"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.innerIsEditing,
                      expression: "innerIsEditing"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.innerIsEditing
                        ? _vm.$t("common.btn.cancel")
                        : _vm.$t("common.btn.close")
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }